import { Stack, Text, Alert, Code } from "@mantine/core";
import { Info } from "lucide-react";
import { UseFormReturnType } from "@mantine/form";
import { SqlEditor } from "@/components/common/SqlEditor";
import type { TableSchema } from "@bi-studio/shared/lib";

interface ReportQueryConfigProps {
    form: UseFormReturnType<any>;
    isSaving: boolean;
    schema: TableSchema[];
    error?: string | null;
}

export function ReportQueryConfig({
    form,
    isSaving,
    schema,
    error,
}: ReportQueryConfigProps) {
    return (
        <Stack gap="md">
            <Stack gap="xs">
                <Text fw={500} size="sm">SQL Query</Text>
                <Alert icon={<Info size={16} />} title="Using Variables" color="gray" variant="light" radius="md">
                    <Stack gap="xs">
                        <Text size="sm">
                            Use <Code>{`{{variableName}}`}</Code> syntax to add parameters to your SQL.
                            Users will be prompted for these values when running the report.
                        </Text>
                        <Text size="sm" fw={500}>
                            Predefined Variables:
                        </Text>
                        <Text size="sm">
                            Variables like <Code>{`{{_user_id}}`}</Code> and <Code>{`{{_company_id}}`}</Code> are automatically populated based on the logged-in user and do not require user input.
                        </Text>
                    </Stack>
                </Alert>
                <SqlEditor
                    value={form.values.query || ""}
                    onChange={(value) => form.setFieldValue("query", value || "")}
                    readOnly={isSaving}
                    height="400px"
                    schema={schema}
                />
            </Stack>

            {error && (
                <Text color="red" size="sm">
                    {error}
                </Text>
            )}
        </Stack>
    );
}
